interface GamesGridSkeletonProps {
  count?: number;
  /** Tailwind aspect class to match the real cards (poster vs wide lottery). */
  aspect?: string;
}

// Content-shaped loading placeholder for the game grids. Full-opacity surface +
// a name line so it reads as "loading a card" on the near-black page, not as an
// empty/broken tile (a flat low-opacity box was indistinguishable from a dead grid).
export function GamesGridSkeleton({ count = 10, aspect = 'aspect-[3/4]' }: GamesGridSkeletonProps) {
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex flex-col gap-2">
          <div className={`${aspect} w-full rounded-2xl bg-[var(--bg-elevated)] animate-pulse`} />
          <div className="h-3 w-3/4 rounded bg-[var(--bg-elevated)] animate-pulse" />
        </div>
      ))}
    </div>
  );
}
